<template>
  <v-select
    v-model="group"
    item-value="id"
    item-text="name"
    :label="label"
    :items="items"
    :loading="!!!items.length || loading"
    :error-messages="errorMessages"
    :multiple="multiple"
    :readonly="readonly"
    :cache-items="true"
    :chips="chips"
    :small-chips="smallChips"
    :clearable="clearable"
    @input="updateValue('group', $event)"
  >
  </v-select>
</template>

<script>
import { requiredSelectNotArray } from '@/modules/_global/variables/rules';
import { mapCacheActions } from 'vuex-cache';

export default {
  name: 'GroupSelect',

  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    chips: {
      type: Boolean,
      default: false
    },
    smallChips: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: null
    },
    rules: {
      type: Array,
      default: () => requiredSelectNotArray
    }
  },

  data: () => ({
    group: null,
    items: []
  }),

  watch: {
    value: {
      deep: true,
      handler: 'setData'
    }
  },

  created() {
    this.getGroups().then(({ data }) => {
      this.items = data.data;
    });
  },

  methods: {
    ...mapCacheActions('service', ['getGroups']),

    setData() {
      if (this.value !== null) {
        this.group = this.value;
      }
    },
    updateValue(field, v) {
      if (v !== this.value) {
        this.$emit('input', v);
      }
    }
  }
};
</script>
